/**
 * @file
 */

export default {
    setFilterQuery({commit}, query) {
        commit('setFilterQuery', query);
    },
    clearFilterQuery({commit}) {
        commit('clearFilterQuery');
    },
    setCheckedProcess({commit}, val) {
        commit('setInitSelectProcess', val);
    },
    setChecked({commit}, val) {
        commit('setInitProcessState', val);
        if (val) {
            commit('setInitSelectProcess', []);
        }
    },
    // 获取只查未回复的帖子的选中状态
    setReply({commit}, val) {
        commit('setInitReply', val);
    },
    changeFollower({commit}, followInfo) {
        commit('setInitFollowInfo', followInfo);
    },
    changeAuthor({commit}, authorInfo) {
        commit('setInitAuthorInfo', authorInfo);
    },
    changeFollowerOfIssue({commit}, followInfo) {
        commit('setInitIssueFollowInfo', followInfo);
    },
    setSelectedTime({commit}, time) {
        commit('setSelectedTime', time);
    },
    // 清空流程筛选
    clearProcessState({commit}) {
        commit('setInitProcessState', true);
        commit('setInitSelectProcess', []);
    },
    // 清空只查未回复的帖子的选中状态
    clearReply({commit}) {
        commit('setInitReply', false);
    },
    // 清空跟进人
    clearFollowInfo({commit}) {
        commit('setInitFollowInfo', {});
    },
    clearAuthorInfo({commit}) {
        commit('setInitAuthorInfo', {});
    },
    clearIssueFollowInfo({commit}) {
        commit('setInitIssueFollowInfo', {});
    },
    // 清空时间筛选
    clearTime({commit}) {
        commit('setSelectedTime', '');
    },
    clearFilterState({dispatch}) {
        dispatch('clearProcessState');
        dispatch('clearFollowInfo');
        dispatch('clearReply');
        dispatch('clearAuthorInfo');
        dispatch('clearIssueFollowInfo');
        dispatch('clearTime');

        // 清空保存的筛选参数
        dispatch('clearFilterQuery');
    }
};
